import { useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';

export const useReadMessage = (message, onRead) => {
  const { ref, inView } = useInView();
  const hasReadRef = useRef(false);

  useEffect(() => {
    if (inView && message.is_read !== true && onRead && !hasReadRef.current) {
      hasReadRef.current = true;
      onRead(message.id, message.chat_id, message.sender_id);
    }
  }, [inView, message, onRead]);

  return ref;
};
